export const DEFAULT_MIN_TEXT_LENGTH = 1
export const DEFAULT_MAX_TEXT_LENGTH = 1000
export const SKIPPER_AUTHOR_ID = '@skipper'
export const MESSAGE_GROUPING_THRESHOLD = 5 * 60 * 1000

export const ACCEPTED_FILE_TYPES = [
  'image/*',
  'video/*',
  // Documents (MIME types for validation)
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.apple.keynote',
  'application/vnd.apple.pages',
  'application/vnd.apple.numbers',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.presentation',
  'application/zip',
  'application/x-rar-compressed',
  'application/vnd.rar',
  'application/x-7z-compressed',
  'text/*',
  'text/csv',
  'application/octet-stream'
]

// File extensions for the file input accept attribute (browsers match extensions more reliably than MIME types)
export const ACCEPTED_FILE_EXTENSIONS = [
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  '.key',
  '.pages',
  '.numbers',
  '.odt',
  '.ods',
  '.odp',
  '.zip',
  '.rar',
  '.7z',
  '.csv',
  '.txt'
]

export const FILE_INPUT_ACCEPT = ['image/*', 'video/*', ...ACCEPTED_FILE_EXTENSIONS].join(',')

export const MAX_FILE_SIZE = 20 * 1024 * 1024
export const MAX_VIDEO_FILE_SIZE = 100 * 1024 * 1024
export const MAX_FILE_NAME_LENGTH = 120
export const MAX_ATTACHMENTS = 5

export const PREVIEWABLE_IMAGE_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/svg+xml',
  'image/bmp',
  'image/avif',
  'image/apng'
])

export const PREVIEWABLE_VIDEO_TYPES = new Set(['video/mp4', 'video/webm', 'video/ogg'])

export function isBrowserPreviewable(mimeType: string): boolean {
  return PREVIEWABLE_IMAGE_TYPES.has(mimeType) || PREVIEWABLE_VIDEO_TYPES.has(mimeType)
}

const EXTENSION_MIME_MAP: Record<string, string> = {
  '.pdf': 'application/pdf',
  '.doc': 'application/msword',
  '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.xls': 'application/vnd.ms-excel',
  '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.ppt': 'application/vnd.ms-powerpoint',
  '.pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  '.key': 'application/vnd.apple.keynote',
  '.pages': 'application/vnd.apple.pages',
  '.numbers': 'application/vnd.apple.numbers',
  '.odt': 'application/vnd.oasis.opendocument.text',
  '.ods': 'application/vnd.oasis.opendocument.spreadsheet',
  '.odp': 'application/vnd.oasis.opendocument.presentation',
  '.zip': 'application/zip',
  '.rar': 'application/vnd.rar',
  '.7z': 'application/x-7z-compressed',
  '.csv': 'text/csv',
  '.txt': 'text/plain',
  '.mkv': 'video/x-matroska',
  '.avi': 'video/x-msvideo',
  '.wmv': 'video/x-ms-wmv',
  '.mov': 'video/quicktime',
  '.flv': 'video/x-flv'
}

export function resolveFileMimeType(file: File): string {
  if (file.type && file.type !== 'application/octet-stream') return file.type
  const ext = file.name.includes('.') ? file.name.slice(file.name.lastIndexOf('.')).toLowerCase() : ''
  return EXTENSION_MIME_MAP[ext] || file.type || 'application/octet-stream'
}
